import { render, staticRenderFns } from "./ContactOthersPage.vue?vue&type=template&id=55cdaa8e&scoped=true"
import script from "./ContactOthersPage.vue?vue&type=script&lang=js"
export * from "./ContactOthersPage.vue?vue&type=script&lang=js"
import style0 from "./ContactOthersPage.vue?vue&type=style&index=0&id=55cdaa8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cdaa8e",
  null
  
)

export default component.exports